<template>
  <div class="surveyLabel">

  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {
    var _this = this
  },
  props: ['item']
}
</script>

